export const iconFontAwesomeTravelHotelWheelchair = (
	<i className="fa-solid fa-wheelchair"></i>
);
